import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Badge } from "./ui/badge";
import "./faq.css";

const FAQ = () => {
  const [activeCategory, setActiveCategory] = useState('services');
  const [expandedFAQ, setExpandedFAQ] = useState(null);

  const faqData = {
    services: {
      title: "サービスについて",
      items: [
        {
          id: 1,
          question: "具体的なサービス領域は？",
          answer: "1. LLM／チャットボット開発 2. 量子・物理リザバー応用 3. 企業向けAI内製化支援 4. データ分析 & BI 5. 教育コンテンツ／研修"
        },
        {
          id: 2,
          question: "開発の流れを教えてください。",
          answer: "①ヒアリング → ②PoC設計 → ③実装／検証 → ④本番導入 → ⑤運用最適化 の5段階。各フェーズで成果物と評価指標（KPI）を明確化します。"
        },
        {
          id: 3,
          question: "相談だけでも可能？",
          answer: "はい。初回60分の無料カウンセリングをオンラインで実施しています。"
        },
        {
          id: 4,
          question: "既存システムが古くても連携できますか？",
          answer: "レガシーERP・オンプレDB向けにRAGやETL基盤を用意。段階的マイグレーションも支援します。"
        },
        {
          id: 5,
          question: "導入後のサポートは？",
          answer: "運用監視・モデル再学習・ユーザートレーニングを含む保守プラン（月額30万円〜）をご用意。"
        },
        {
          id: 6,
          question: "プロジェクト期間の目安は？",
          answer: "小規模PoC：1〜2か月、中規模プロダクト：3〜6か月、研究開発(量子／EEG)：6か月〜"
        },
        {
          id: 7,
          question: "スタートアップでも依頼できる？",
          answer: "もちろんです。シード向けにはミニマム機能開発パッケージ（100万円／6週間）を提供しています。"
        },
        {
          id: 8,
          question: "海外案件の対応言語は？",
          answer: "日本語・英語で対応可。必要に応じて多言語ローカライズパートナーを手配します。"
        }
      ]
    },
    partnership: {
      title: "パートナーシップについて",
      items: [
        {
          id: 9,
          question: "パートナー／代理店制度はある？",
          answer: "あります。紹介手数料または共同受注型（成果報酬20%〜）が選択可能。"
        }
      ]
    },
    technical: {
      title: "技術について",
      items: [
        {
          id: 10,
          question: "機密情報の取扱いは安全？",
          answer: "全案件でNDAを締結。開発環境はAWSの日本リージョン、データは暗号化・アクセス権限を厳格管理します。"
        },
        {
          id: 11,
          question: "量子機械学習（QML）の強みは？",
          answer: "量子回路最適化とリザバーアーキテクチャを掛け合わせ、高次元・非線形データのリアルタイム予測精度を向上させます。"
        }
      ]
    },
    company: {
      title: "会社について",
      items: [
        {
          id: 12,
          question: "DeepTeLLはどんな会社ですか？",
          answer: "生成AI・量子機械学習（QML）・脳波解析（EEG）など最先端ディープテックを武器に、システム開発・AIコンサル・研究開発支援をワンストップで提供するテクノロジーカンパニーです。"
        },
        {
          id: 13,
          question: "料金体系は？",
          answer: "・PoC：月額 100 万円〜 ・フル導入：要件に応じ個別見積り 結果連動型やレベニューシェアにも柔軟対応。"
        },
        {
          id: 14,
          question: "人材募集はしていますか？",
          answer: "エンジニア・PM・研究員を通年採用中。ご興味ある方は careers@deeptell.jp へ履歴書をお送りください。"
        },
        {
          id: 15,
          question: "問い合わせ方法は？",
          answer: "Webフォーム（https://deeptell.jp/contact/general）または info@deeptell.jp へメールでご連絡ください。営業日24時間以内に折り返します。"
        }
      ]
    }
  };

  const categories = Object.keys(faqData);

  const toggleFAQ = (id) => {
    setExpandedFAQ(expandedFAQ === id ? null : id);
  };

  return (
    <div id="faq" style={{ backgroundColor: '#0f172a', minHeight: '100vh' }}>
      {/* カテゴリータブ */}
      <section style={{ padding: '60px 0 40px' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title text-center">
                <h2 style={{ color: '#f1f5f9', marginBottom: '20px' }}>よくある質問</h2>
                <p style={{ color: '#cbd5e1', marginBottom: '40px' }}>
                  DeepTeLLのサービスやパートナーシップに関するご質問にお答えします
                </p>
              </div>
              <div className="text-center">
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                  {categories.map((category) => (
                    <button
                      key={category}
                      onClick={() => setActiveCategory(category)}
                      style={{
                        padding: '12px 24px',
                        borderRadius: '25px',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        background: activeCategory === category ? '#3b82f6' : 'transparent',
                        color: activeCategory === category ? 'white' : '#cbd5e1',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        fontSize: '16px'
                      }}
                    >
                      {faqData[category].title}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ内容 */}
      <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: '#f1f5f9', marginBottom: '40px', textAlign: 'center' }}>
                {faqData[activeCategory].title}
              </h2>
              
              {faqData[activeCategory].items.map((faq) => (
                <div 
                  key={faq.id} 
                  style={{ 
                    marginBottom: '20px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    overflow: 'hidden'
                  }}
                >
                  <div 
                    onClick={() => toggleFAQ(faq.id)}
                    style={{ 
                      padding: '20px 30px',
                      cursor: 'pointer',
                      borderBottom: expandedFAQ === faq.id ? '1px solid rgba(59, 130, 246, 0.2)' : 'none',
                      transition: 'background-color 0.3s'
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h4 style={{ color: '#f1f5f9', margin: 0, flex: 1, paddingRight: '20px' }}>
                        Q. {faq.question}
                      </h4>
                      <div style={{ 
                        color: '#3b82f6', 
                        fontSize: '24px',
                        transform: expandedFAQ === faq.id ? 'rotate(45deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s'
                      }}>
                        +
                      </div>
                    </div>
                  </div>
                  
                  {expandedFAQ === faq.id && (
                    <div style={{ 
                      padding: '20px 30px',
                      background: 'rgba(15, 23, 42, 0.5)',
                      animation: 'slideDown 0.3s ease-out'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <div style={{ 
                          color: '#3b82f6', 
                          fontSize: '16px', 
                          fontWeight: 'bold',
                          marginRight: '15px',
                          marginTop: '2px'
                        }}>
                          A.
                        </div>
                        <p style={{ color: '#cbd5e1', lineHeight: '1.6', margin: 0 }}>
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            max-height: 0;
          }
          to {
            opacity: 1;
            max-height: 200px;
          }
        }
      `}</style>
    </div>
  );
};

export default FAQ;
